export {
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  ThemeProvider,
  createComponent,
  createFactory,
  getControlledDerivedProps,
  getSlots,
  legacyStyled,
  useControlledState,
  withSlots,
} from '@fluentui/foundation-legacy';
export type {
  ExtractProps,
  ExtractShorthand,
  IComponent,
  IComponentOptions,
  IComponentStyles,
  IControlledStateOptions,
  ICustomizationProps,
  IDefaultSlotProps,
  IFactoryOptions,
  IHTMLElementSlot,
  IHTMLSlot,
  IProcessedSlotProps,
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  IPropsWithChildren,
  ISlot,
  ISlotCreator,
  ISlotDefinition,
  ISlotFactory,
  ISlotOptions,
  ISlotProp,
  ISlotRender,
  ISlots,
  ISlottableComponentType,
  ISlottableProps,
  ISlottableReactType,
  IStateComponentType,
  IStyleableComponentProps,
  IStylesFunction,
  IStylesFunctionOrObject,
  IThemeProviderProps,
  IToken,
  ITokenBase,
  ITokenBaseArray,
  ITokenFunction,
  ITokenFunctionOrObject,
  IViewComponent,
  ValidProps,
  ValidShorthand,
} from '@fluentui/foundation-legacy';
